import api from './api';

// 활동 로그 타입 정의
export interface ActivityLog {
  id: number;
  userId?: number;
  username: string;
  menuName: string;
  action: 'CREATE' | 'UPDATE' | 'DELETE' | 'VIEW' | 'TOGGLE' | 'APPROVE' | 'REJECT' | 'PASSWORD_CHANGE';
  targetType: string;
  targetId?: number;
  content: string;
  metadata?: Record<string, any>;
  createdAt: string;
  user?: {
    id: number;
    username: string;
    email: string;
    role: string;
  };
}

// 리포트 목록 조회 파라미터
export interface ReportListParams {
  page?: number;
  limit?: number;
  menuName?: string;
  role?: string;
  search?: string;
  startDate?: string; // YYYY-MM-DD
  endDate?: string;   // YYYY-MM-DD
}

// 리포트 목록 응답
export interface ReportListResponse {
  success: boolean;
  data: {
    logs: ActivityLog[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
      hasNextPage: boolean;
      hasPrevPage: boolean;
    };
  };
}

// 필터 옵션 응답
export interface ReportFiltersResponse {
  success: boolean;
  data: {
    menuNames: string[];
    usernames: string[];
  };
}

// 통계 응답
export interface ReportStatsResponse {
  success: boolean;
  data: {
    totalLogs: number;
    logsToday: number;
    logsByMenu: Array<{
      menuName: string;
      count: number;
    }>;
    logsByAction: Array<{
      action: string;
      count: number;
    }>;
  };
}

class ReportService {
  /**
   * 활동 로그 목록 조회
   * @param params 필터 파라미터
   */
  async getReports(params?: ReportListParams): Promise<ReportListResponse> {
    const response = await api.get('/reports', { params });
    return response.data;
  }

  /**
   * 필터 옵션 조회 (메뉴명, 관리자명 목록)
   */
  async getReportFilters(): Promise<ReportFiltersResponse> {
    const response = await api.get('/reports/filters');
    return response.data;
  }

  /**
   * 통계 정보 조회
   */
  async getReportStats(): Promise<ReportStatsResponse> {
    const response = await api.get('/reports/stats');
    return response.data;
  }
}

export const reportService = new ReportService();
export default reportService;
